import React from "react";
import { Button } from "../ui/button";
import { MessageCircle, Calendar, PawPrint } from "lucide-react";
import { waLink } from "../../lib/site";
import Reveal from "../Reveal";

export default function CTA() {
  return (
    <section data-testid="cta-section" className="relative py-20 sm:py-24 bg-white">
      <div className="container-pad">
        <Reveal as="div" className="relative overflow-hidden rounded-[36px] bg-royal text-white p-10 sm:p-16 grain">
          <div className="absolute -top-10 -right-10 w-72 h-72 rounded-full bg-gold/25 blur-3xl" />
          <div className="absolute -bottom-12 -left-10 w-72 h-72 rounded-full bg-sky-soft/15 blur-3xl" />
          <PawPrint className="absolute top-8 right-8 w-16 h-16 text-gold/20" />

          <div className="relative max-w-3xl">
            <span className="inline-block px-3 py-1 rounded-full bg-gold text-royal text-xs font-bold uppercase tracking-[0.18em] mb-5">
              Cuide do seu melhor amigo
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-[1.1]">
              Pronto para presentear seu pet com <span className="italic text-gold">o melhor cuidado</span>?
            </h2>
            <p className="mt-5 text-white/80 text-base sm:text-lg leading-relaxed">
              Agende agora pelo site ou fale conosco no WhatsApp. Vamos cuidar de tudo com carinho.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button
                data-testid="cta-agendar"
                asChild
                className="rounded-full bg-gold hover:bg-gold-hover text-royal font-bold px-7 py-6 shadow-lg"
              >
                <a href="#agendamento">
                  <Calendar className="w-5 h-5 mr-2" />
                  Agendar Atendimento
                </a>
              </Button>
              <Button
                data-testid="cta-whatsapp"
                asChild
                variant="outline"
                className="rounded-full bg-transparent border-2 border-white text-white hover:bg-white hover:text-royal font-semibold px-7 py-6"
              >
                <a href={waLink()} target="_blank" rel="noreferrer">
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Falar no WhatsApp
                </a>
              </Button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
